/* eslint-disable no-unused-vars */
import { Flex } from '@chakra-ui/react'
import noop from 'lodash/noop'

import RecordAudio from '../HelperComponents/RecordAudio'
import WatchVideo from '../HelperComponents/WatchVideo'

const WatchWithRecord = ({ exercise, setSelectedAnswer }) => {
  return (
    <Flex gap={4} direction={['column', 'column', 'row']} alignItems={'center'}>
        <WatchVideo exercise={exercise} />
      <RecordAudio
        key={exercise.id}
        setSelectedAnswer={setSelectedAnswer}
        onStopRecording={noop}
      />
    </Flex>
  )
}

export default WatchWithRecord
